import * as React from 'react';
import {FunctionComponent} from 'react';
import {FullWorkout} from '../../../Models/FullWorkout';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    token: string;
    fullWorkout: FullWorkout;
    className?: string;
}

export const Claim: FunctionComponent<OwnProps> = ({token, fullWorkout, className}) => {
    if (fullWorkout.is_claimed) {
        return null;
    }

    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Claim</h5>
            </div>
            <div className="card-body">
                <p>Looking for more insights and workouts visualisations?</p>
                <p>If this is your workout, you can add it to your profile.</p>
                <div className="input-group mb-3 d-flex flex-row justify-content-end">
                    <a
                        className="btn btn-primary"
                        href={`/workout/${fullWorkout.id}/claim?token=${encodeURIComponent(token)}`}
                    >
                        Add to your profile
                    </a>
                </div>
            </div>
        </div>
    );
};
